module.exports = __webpack_public_path__ + "static/condo-4-56fae79c5fe4aab48dcea7f0c326ac79.jpg";